import Navbar from "../components/Navbar";
import Banner from "../components/Banner";
import Footer from "../components/Footer";
import FeatureCard from "../components/FeatureCard";
import Video from "../components/Video";

function Home() {
  return (
    <>
      <Navbar />
      <section id="banner">
        <Banner />
      </section>
      <section id="card">
        <FeatureCard />
      </section>
      <Video />
      <Footer />
    </>
  );
}
export default Home;